export class W3Video {
  private videoContainer: HTMLElement | null =
    document.querySelector(".w3-video");
  private videoOverlay: HTMLElement | null =
    document.querySelector(".w3-video--player");
  private videoElement: HTMLVideoElement | null = document.querySelector(
    ".w3-video--player video",
  );

  private videoInner: HTMLElement | null = document.querySelector(
    ".w3-video--player--inner",
  );
  private videoShown = false;

  constructor() {
    if (!this.videoContainer) return;
    this.registerVideoPlayer();
  }

  private registerVideoPlayer() {
    this.videoContainer!.addEventListener("click", (event: MouseEvent) => {
      console.log("click target: ", event.target);
      event.preventDefault();
      // Determine if the click is on elements that should not close the modal
      const withinInteractiveArea = (event.target as HTMLElement).closest(
        ".w3-video--player--inner, video, .w3-video-controls",
      );

      if (!withinInteractiveArea) {
        if (this.videoShown) {
          this.videoElement!.pause();
          this.videoElement!.currentTime = 0;
          this.videoShown = false;
          this.videoOverlay!.classList.toggle("active");
        } else {
          this.videoElement!.play();
          this.videoShown = true;
          this.videoOverlay!.classList.toggle("active");
        }
      }
    });
  }
}
